export default ({ allocationProject, columnType, isStatic }) => {
  if (allocationProject) {
    return {
      id: `${allocationProject.id}-${columnType}`,
      allocationProjectId: allocationProject.id,
      allocationProject,
      columnType,
      notification: {},
      ...(isStatic !== undefined ? { isStatic } : {}),
    };
  }
  return {
    id: columnType,
    allocationProjectId: null,
    allocationProject: null,
    columnType,
    notification: {},
  };
};
